import React from "react";
import "./ActionButton.scss"

const ActionButton = (props) => {

    return (
        <button onClick={props.onClick} className="btn btn-shadow compose-btn btn-primary text-uppercase action-button">
            <i className={"icon " + props.icon + " icon-fw mr-2"}/>{props.title}</button>
    );
};

ActionButton.defaultProps = {
    icon: 'icon-edit'
};

export default ActionButton ;